import * as React from "react";
const SvgAmpStories = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 4h10v15H7zM3 6h2v11H3zm16 0h2v11h-2z",
  fill: "currentColor"
}));
export default SvgAmpStories;